// @flow

import React, { Component } from 'react';
import { PieChart, Pie, Tooltip, Cell } from 'recharts';

// header

type Props = {
    width?: number,
    propsResults: { [key: string]: any },
    showResultsView: boolean,
    handleResultsViewClick: Function
};

class PropsResults extends Component<Props> {
    render() {
        let resultData;

        const COLORS = ['#1BFB21 ', '#FF6B6A', '#F6F6F6'];
        const RADIAN = Math.PI / 180;
        const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
            const radius = innerRadius + (outerRadius - innerRadius) * 0.25;
            const x = cx + radius * Math.cos(-midAngle * RADIAN);
            const y = cy + radius * Math.sin(-midAngle * RADIAN);

            return (
                <text x={x} y={y} fill="#666" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
                    {`${(percent * 100).toFixed(0)}%`}
                </text>
            );
        };

        if (this.props.propsResults && this.props.propsResults.results && this.props.propsResults.results.length > 0) {
            if (!!this.props.width && this.props.width < 1420 && this.props.propsResults.results.length > 5) {
                this.props.propsResults.results.pop();
            }

            resultData = (
                <div className="display-table">
                    <div className="results-header">
                        <button
                            className="btn-chevron results-arrow"
                            style={{ display: this.props.showResultsView === true ? 'inline-block' : 'none' }}
                            onClick={() => this.props.handleResultsViewClick()}
                        >
                            <i className="fa fa-chevron-up" style={{ display: 'inline-block', marginRight: 10 }} />
                            <span>Record by Bet Quality</span>
                        </button>
                        <button
                            className="btn-chevron results-arrow"
                            style={{ display: this.props.showResultsView === true ? 'none' : 'inline-block' }}
                            onClick={() => this.props.handleResultsViewClick()}
                        >
                            <i className="fa fa-chevron-down" style={{ display: 'inline-block', marginRight: 10 }} />
                            <span>Record by Bet Quality</span>
                        </button>
                    </div>
                    <div
                        className="display-results"
                        style={{ display: this.props.showResultsView === true ? 'block' : 'none' }}
                    >
                        <ul className="result-list">
                            {this.props.propsResults.results.map(result => {
                                const data = [
                                    { name: 'Wins', value: result.total_wins },
                                    { name: 'Losses', value: result.total_losses },
                                    { name: 'Pushes', value: result.total_pushes }
                                ];

                                const resultDisplay = (
                                    <li className="result-list-item" key={'quality-' + result.bet_quality}>
                                        <div className="result-item-quality">
                                            <h3>{result.bet_quality}</h3>
                                        </div>
                                        <PieChart width={225} height={175}>
                                            <Pie
                                                isAnimationActive={false}
                                                dataKey="value"
                                                data={data}
                                                innerRadius={30}
                                                outerRadius={60}
                                                labelLine={false}
                                                label={renderCustomizedLabel}
                                            >
                                                {data.map((entry, index) => (
                                                    <Cell
                                                        key={'quality-' + result.bet_quality + index}
                                                        fill={COLORS[index % COLORS.length]}
                                                    />
                                                ))}
                                            </Pie>
                                            <Tooltip />
                                        </PieChart>
                                    </li>
                                );
                                return resultDisplay;
                            })}
                        </ul>
                    </div>
                </div>
            );
        } else {
            resultData = 'No results during the selected dates.';
        }

        const display = <div style={{ display: 'flex' }}>{resultData}</div>;

        return display;
    }
}

export default PropsResults;



// WEBPACK FOOTER //
// ./src/components/Main/PlayerProps/PropsResults.js